// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"f5c1998c","660":"505fa0d8"}[chunkId] + ".chunk.js";
};